module.exports = __webpack_public_path__ + "img/we.6ec854bc.png";